export const MODAL = 'MODAL';

const defaultState = {
  name: null,
  title: null,
  message: null,
  confirmLabel: "Yes",
  cancelLabel: "No",
  isLoading: false
};

export default (state = defaultState, action) => {
  switch(action.type) {
    case MODAL:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
};
